// @flow
import $ from 'jquery';
import JQueryView from '../../common/JQueryView';

// app/javascript/application/views/company/stock_options/forms/TermAndConditionsView.js を参考にしてます
export default class Notification extends JQueryView {
  buttonDisabled: boolean;

  constructor() {
    super('.component-v2');
    this.buttonDisabled = false;

    const el = document.getElementById(
      'company_procedure_stock_option_all_confirm',
    );
    if (el) {
      el.addEventListener('click', this.onClickCustomControlInput);
    }
  }

  // 確認状態によってボタンを有効無効にする
  // HACK: @onを利用するとイベントが2度発生し制御できないため利用していない
  // @on({ event: 'click', selector: '.custom-control-input' })
  onClickCustomControlInput() {
    this.buttonDisabled = !this.buttonDisabled;
    if (this.buttonDisabled) {
      $('#company_procedure_stock_option_begin_button').removeClass('disabled');
      $('#company_procedure_stock_option_begin_button').removeAttr('disabled');
    } else {
      $('#company_procedure_stock_option_begin_button').addClass('disabled');
      $('#company_procedure_stock_option_begin_button').attr('disabled');
    }
  }
}
